import { useEffect } from "react";

export const SUPPORT_TYPES = {
  emergency: "Emergency",
  helpline: "Helpline",
  "text-chat": "Text or chat",
  "support-groups": "Support groups",
  information: "Information",
  "local-services": "Local services",
};

export const AUDIENCES = {
  anyone: "Anyone",
  families: "Families",
  parents: "Parents",
  partners: "Partners",
  friends: "Friends",
  "children-young-people": "Children and young people",
};

export const NAV = [
  { to: "/", label: "Home", id: "home" },
  { to: "/find-your-way", label: "Find Your Way", id: "find-your-way" },
  { to: "/direction", label: "Direction", id: "direction" },
  { to: "/support", label: "Support", id: "support" },
  { to: "/understanding", label: "Understanding", id: "understanding" },
  { to: "/about", label: "About Us", id: "about" },
];

export const QUICK_EXIT_URL = "https://www.bbc.co.uk/weather";

export const POSITIONING = "Addiction & Us provides free information, practical guidance and trusted signposting for families and friends affected by addiction. We are not an emergency service or a substitute for professional medical, psychological or safeguarding support.";

export const CONTACT_EMAIL = "Callum.bmgt@gmail.com";
export const SAFEGUARDING_LEAD = "the founder, Callum Butterworth";
export const PRIVACY_LEAD = "Callum Butterworth";
export const OPERATOR = "Addiction & Us is independently operated by its founder, Callum Butterworth. It is not a registered charity or a limited company";

export const CONTACT_ROUTES = [
  { id: "partnerships", title: "Partnerships, media and speaking", email: CONTACT_EMAIL, subject: "Partnership or media enquiry",
    for: "Corporate partnerships, employer wellbeing programmes, professional collaborations, sponsorship and funding, media and speaking requests.",
    include: "Your name, organisation and what you'd like to discuss." },
  { id: "privacy", title: "Privacy and data protection", email: CONTACT_EMAIL, subject: "Privacy request",
    for: "Requests to access, correct or delete personal information, and any other privacy concern or data protection right.",
    include: "What you're asking for and how we can confirm it's you. You don't need to explain why." },
  { id: "report", title: "Report unsafe or incorrect content", email: CONTACT_EMAIL, subject: "Content report",
    for: "Potentially unsafe guidance, incorrect crisis or helpline details, harmful or misleading content, or a safeguarding concern about this website.",
    include: "The page address and what's wrong. Please don't include details about yourself or anyone else." },
  { id: "technical", title: "Technical and accessibility issues", email: CONTACT_EMAIL, subject: "Website or accessibility issue",
    for: "Broken links, website errors, accessibility barriers and other technical faults.",
    include: "The page address, your device and browser, and what happened." },
];

export function useSeo(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | Addiction & Us` : "Addiction & Us | Because addiction affects more than one person";
    if (description) {
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }
  }, [title, description]);
}
